angular.module('lsnBase.deprecated.models')
  .factory('UploadedFileModel', ['LsnUploadedFileModelV1',
    function(LsnUploadedFileModelV1) {
      return LsnUploadedFileModelV1;
    }
  ]);